import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link, useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from "firebase/firestore";
import { Accordion, Button, Table, Container, Modal, Form } from "react-bootstrap";
import db from "./Firebase";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ActiveMembersTable = () => {

    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState("All");
    const tableRef = useRef(null);
    const [searchPhone, setSearchPhone] = useState("");

    useEffect(() => {
        async function loadMembers() {
            setLoading(true);
            const today = moment();

            const memSnap = await getDocs(
                query(collection(db, "nv_glow_membership"), where("end_date", ">=", today.toDate()))
            );
            const members = memSnap.docs.map(d => ({ id: d.id, ...d.data() }));

            const txSnap = await getDocs(
                query(collection(db, "nv_transaction_history"), where("expiryDate", ">=", today.toDate()))
            );
            const txs = txSnap.docs.map(d => ({ id: d.id, ...d.data() }));

            const txMap = new Map(txs.map(tx => [tx.phone, tx]));

            const combined = members.map((m, idx) => {
                const tx = txMap.get(m.phone_no);
                const rawStart = tx?.startDate?.toDate() || m.start_date?.toDate() || null;
                const rawEnd = tx?.expiryDate?.toDate() || m.end_date?.toDate() || null;

                return {

                    phone: m.phone_no,
                    membershipType: m.membership_type,
                    status: "Active",
                    type: tx ? tx.subtitle : "Free",
                    startDateRaw: rawStart,
                    endDateRaw: rawEnd,
                };
            });

            const sorted = combined.sort((a, b) => {
                const dateA = a.startDateRaw || new Date(0);
                const dateB = b.startDateRaw || new Date(0);
                return dateB - dateA; // descending (latest first)
            });

            setRows(sorted);
            setLoading(false);
        }

        loadMembers();
    }, []);




    // const filteredRows = rows.filter(r => {
    //     if (filter === "All") return true;
    //     if (filter === "Free") return r.type === "Free";
    //     return r.membershipType.toLowerCase().includes(filter.toLowerCase());
    // });

    const filteredRows = rows.filter(r => {
        const matchesType =
            filter === "All"
                ? true
                : filter === "Free"
                    ? r.type === "Free"
                    : r.membershipType.toLowerCase().includes(filter.toLowerCase());

        const matchesPhone = r.phone.includes(searchPhone.trim());

        return matchesType && matchesPhone;
    });

    const handleExport = () => {
        const worksheetData = [
            ["Phone", "Membership Type", "Status", "Type", "Start Date", "End Date"],
            ...filteredRows.map(r => [

                r.phone,
                r.membershipType,
                r.status,
                r.type,
                r.startDateRaw ? moment(r.startDateRaw).format("YYYY-MM-DD") : "N/A",
                r.endDateRaw ? moment(r.endDateRaw).format("YYYY-MM-DD") : "N/A"
            ])
        ];
        const ws = XLSX.utils.aoa_to_sheet(worksheetData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ActiveMembers");
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), "ActiveMembers.xlsx");
    };


    return (
        <>
            <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>
            <div className="mb-3 d-flex align-items-center gap-3">


            </div>
            <div className="p-3">
                <div className="card-header pb-0 px-3" style={{ display: "flex" }}>
                    <h4 className="mb-2 mr-4">Active Memberships</h4>

                    <Form.Control
                        type="text"
                        placeholder="Search by Phone Number..."
                        value={searchPhone}
                        onChange={e => setSearchPhone(e.target.value)}
                        style={{ width: "300px" }}
                    />

                    {/* <input
                        type="text"
                        placeholder="Search by phone..."
                        value={searchPhone}
                        onChange={e => setSearchPhone(e.target.value)}
                        style={{ marginLeft: 10 }}
                    /> */}

                    {/* <label>Filter: </label> */}
                    <select value={filter} onChange={e => setFilter(e.target.value)} style={{ width: "14rem", height: "34px", marginLeft: "1rem" }}>
                        <option value="All">All</option>
                        <option value="Free">Free</option>
                        <option value="Glow">Glow</option>
                        <option value="Glow Plus">Glow Plus</option>
                        <option value="Glow Max">Glow Max</option>
                    </select>

                    <div className="ml-4">
                        <Button variant="success" onClick={handleExport}>
                            Download Excel
                        </Button>
                    </div>
                </div>
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>#</th>
                                <th>Phone</th>
                                <th>Membership Type</th>
                                <th>Status</th>
                                <th>Type</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRows.map((r, index) => (
                                <tr key={r.phone}>
                                    <td>{index + 1}</td>
                                    <td>{r.phone}</td>
                                    <td>{r.membershipType}</td>
                                    <td>{r.status}</td>
                                    <td>{r.type}</td>
                                    <td>{r.startDateRaw ? moment(r.startDateRaw).format("MMM Do YY") : "N/A"}</td>
                                    <td>{r.endDateRaw ? moment(r.endDateRaw).format("MMM Do YY") : "N/A"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


            </div>
        </>
    );
};

export default ActiveMembersTable;


// import React, { useEffect, useState, useRef } from "react";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import db from "./Firebase";
// import moment from "moment";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const ActiveMembersTable = () => {
//     const [loading, setLoading] = useState(true);
//     const [rows, setRows] = useState([]);
//     const [filter, setFilter] = useState("All");
//     const tableRef = useRef(null);

//     useEffect(() => {
//         async function loadMembers() {
//             setLoading(true);
//             const today = moment();

//             const memSnap = await getDocs(
//                 query(collection(db, "nv_glow_membership"), where("end_date", ">=", today.toDate()))
//             );
//             const members = memSnap.docs.map(d => ({ id: d.id, ...d.data() }));

//             const txSnap = await getDocs(
//                 query(collection(db, "nv_transaction_history"), where("expiryDate", ">=", today.toDate()))
//             );
//             const txs = txSnap.docs.map(d => ({ id: d.id, ...d.data() }));

//             const txMap = new Map(txs.map(tx => [tx.phone, tx]));

//             const combined = members.map((m, idx) => {
//                 const tx = txMap.get(m.phone_no);
//                 const rawStart = tx?.startDate?.toDate() || m.start_date?.toDate() || null;
//                 const rawEnd = tx?.expiryDate?.toDate() || m.end_date?.toDate() || null;

//                 return {

//                     phone: m.phone_no,
//                     membershipType: m.membership_type,
//                     status: "Active",
//                     type: tx ? tx.subtitle : "Free",
//                     startDateRaw: rawStart,
//                     endDateRaw: rawEnd,
//                 };
//             });

//             const sorted = combined.sort((a, b) => {
//                 const dateA = a.startDateRaw || new Date(0);
//                 const dateB = b.startDateRaw || new Date(0);
//                 return dateB - dateA; // descending (latest first)
//             });

//             setRows(sorted);
//             setLoading(false);
//         }

//         loadMembers();
//     }, []);

//     const filteredRows = rows.filter(r => {
//         if (filter === "All") return true;
//         if (filter === "Free") return r.type === "Free";
//         return r.membershipType.toLowerCase().includes(filter.toLowerCase());
//     });

//     const handleExport = () => {
//         const worksheetData = [
//             ["#", "Phone", "Membership Type", "Status", "Type", "Start Date", "End Date"],
//             ...filteredRows.map(r => [

//                 r.phone,
//                 r.membershipType,
//                 r.status,
//                 r.type,
//                 r.startDateRaw ? moment(r.startDateRaw).format("YYYY-MM-DD") : "N/A",
//                 r.endDateRaw ? moment(r.endDateRaw).format("YYYY-MM-DD") : "N/A"
//             ])
//         ];
//         const ws = XLSX.utils.aoa_to_sheet(worksheetData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "ActiveMembers");
//         const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//         saveAs(new Blob([wbout], { type: "application/octet-stream" }), "ActiveMembers.xlsx");
//     };

//     return (
//         <div>
//             <h3>Active Memberships</h3>
//             <div style={{ marginBottom: 10 }}>
//                 <label>Filter: </label>
//                 <select value={filter} onChange={e => setFilter(e.target.value)}>
//                     <option value="All">All</option>
//                     <option value="Free">Free</option>
//                     <option value="Glow">Glow</option>
//                     <option value="Glow Plus">Glow Plus</option>
//                     <option value="Glow Max">Glow Max</option>
//                 </select>
//                 <button onClick={handleExport} style={{ marginLeft: 10 }}>Export to Excel</button>
//             </div>

//             {loading ? <div>Loading...</div> : (
//                 <table ref={tableRef} style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead>
//                         <tr>
//                             <th>#</th><th>Phone</th><th>Membership Type</th><th>Status</th><th>Type</th><th>Start Date</th><th>End Date</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredRows.map((r, index) => (
//                             <tr key={r.phone}>
//                                 <td>{index + 1}</td>
//                                 <td>{r.phone}</td>
//                                 <td>{r.membershipType}</td>
//                                 <td>{r.status}</td>
//                                 <td>{r.type}</td>
//                                 <td>{r.startDateRaw ? moment(r.startDateRaw).format("MMM Do YY") : "N/A"}</td>
//                                 <td>{r.endDateRaw ? moment(r.endDateRaw).format("MMM Do YY") : "N/A"}</td>
//                             </tr>
//                         ))}

//                     </tbody>
//                 </table>
//             )}
//         </div>
//     );
// };

// export default ActiveMembersTable;


// // import React, { useEffect, useState } from "react";
// // import { collection, query, where, getDocs } from "firebase/firestore";
// // import db from "./Firebase";
// // import moment from "moment";

// // const ActiveMembersTable = () => {
// //     const [loading, setLoading] = useState(true);
// //     const [rows, setRows] = useState([]);
// //     const [filter, setFilter] = useState("All");

// //     useEffect(() => {
// //         async function loadMembers() {
// //             setLoading(true);
// //             const today = moment();

// //             const memRef = collection(db, "nv_glow_membership");
// //             const memQ = query(memRef, where("end_date", ">=", today.toDate()));
// //             const memSnap = await getDocs(memQ);
// //             const members = memSnap.docs.map(d => ({ id: d.id, ...d.data() }));

// //             const txRef = collection(db, "nv_transaction_history");
// //             const txQ = query(txRef, where("expiryDate", ">=", today.toDate()));
// //             const txSnap = await getDocs(txQ);
// //             const txs = txSnap.docs.map(d => ({ id: d.id, ...d.data() }));

// //             const txMap = new Map();
// //             txs.forEach(tx => {
// //                 txMap.set(tx.phone, tx);
// //             });

// //             const combined = members.map(m => {
// //                 const phone = m.phone_no;
// //                 const tx = txMap.get(phone);
// //                 const rawStart = tx?.startDate?.toDate() || m.start_date?.toDate() || null;
// //                 const rawEnd = tx?.expiryDate?.toDate() || m.end_date?.toDate() || null;
// //                 return {
// //                     phone,
// //                     membershipType: m.membership_type,
// //                     status: "Active",
// //                     type: tx ? tx.subtitle : "Free",
// //                     startDateRaw: rawStart,
// //                     endDateRaw: rawEnd,
// //                     // startDate: tx
// //                     //     ? moment(tx.startDate.toDate()).format("MMM Do YY")
// //                     //     : m.start_date
// //                     //         ? moment(m.start_date.toDate()).format("MMM Do YY")
// //                     //         : "N/A",
// //                     // endDate: tx
// //                     //     ? moment(tx.expiryDate.toDate()).format("MMM Do YY")
// //                     //     : m.end_date
// //                     //         ? moment(m.end_date.toDate()).format("MMM Do YY")
// //                     //         : "N/A",
// //                 };
// //             });

// //             // 🔽 Sort by real Date
// //             const sorted = combined.sort((a, b) => {
// //                 const dateA = a.startDateRaw ? new Date(a.startDateRaw) : new Date("1970-01-01");
// //                 const dateB = b.startDateRaw ? new Date(b.startDateRaw) : new Date("1970-01-01");
// //                 return dateB - dateA;
// //             })

// //             setRows(sorted);
// //             setLoading(false);
// //         }

// //         loadMembers();
// //     }, []);

// //     const filteredRows = rows.filter(r => {
// //         if (filter === "All") return true;
// //         if (filter === "Free") return r.type === "Free";
// //         return r.membershipType.toLowerCase().includes(filter.toLowerCase());
// //     });

// //     return (
// //         <div>
// //             <h3>Active Memberships</h3>
// //             <div style={{ marginBottom: 10 }}>
// //                 <label>Filter: </label>
// //                 <select value={filter} onChange={e => setFilter(e.target.value)}>
// //                     <option value="All">All</option>
// //                     <option value="Free">Free</option>
// //                     <option value="Glow">Glow</option>
// //                     <option value="Glow Plus">Glow Plus</option>
// //                     <option value="Glow Max">Glow Max</option>
// //                 </select>
// //             </div>

// //             {loading ? (
// //                 <div>Loading...</div>
// //             ) : (
// //                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
// //                     <thead>
// //                         <tr>
// //                             <th>#</th>
// //                             <th>Phone</th>
// //                             <th>Membership Type</th>
// //                             <th>Status</th>
// //                             <th>Type</th>
// //                             <th>Start Date</th>
// //                             <th>End Date</th>
// //                         </tr>
// //                     </thead>
// //                     <tbody>
// //                         {filteredRows.map((r, idx) => (
// //                             <tr key={idx}>
// //                                 <td>{idx + 1}</td>
// //                                 <td>{r.phone}</td>
// //                                 <td>{r.membershipType}</td>
// //                                 <td>{r.status}</td>
// //                                 <td>{r.type}</td>
// //                                 <td>{r.startDateRaw ? moment(r.startDateRaw).format("MMM Do YY") : "N/A"}</td>
// //                                 <td>{r.endDateRaw ? moment(r.endDateRaw).format("MMM Do YY") : "N/A"}</td>
// //                             </tr>
// //                         ))}
// //                     </tbody>
// //                 </table>
// //             )}
// //         </div>
// //     );
// // };

// // export default ActiveMembersTable;



// // // import React, { useEffect, useState } from "react";
// // // import { collection, query, where, getDocs } from "firebase/firestore";
// // // import db from "./Firebase";
// // // import moment from "moment";

// // // const ActiveMembersTable = () => {
// // //     const [loading, setLoading] = useState(true);
// // //     const [rows, setRows] = useState([]);

// // //     useEffect(() => {
// // //         async function loadMembers() {
// // //             setLoading(true);
// // //             const today = moment();

// // //             // 1. Load active memberships (end_date >= today)
// // //             const memRef = collection(db, "nv_glow_membership");
// // //             const memQ = query(memRef, where("end_date", ">=", today.toDate()));
// // //             const memSnap = await getDocs(memQ);
// // //             const members = memSnap.docs.map(d => ({
// // //                 id: d.id,
// // //                 ...d.data(),
// // //             }));

// // //             // 2. Load active transactions (expiryDate >= today)
// // //             const txRef = collection(db, "nv_transaction_history");
// // //             const txQ = query(txRef, where("expiryDate", ">=", today.toDate()));
// // //             const txSnap = await getDocs(txQ);
// // //             const txs = txSnap.docs.map(d => ({
// // //                 id: d.id,
// // //                 ...d.data(),
// // //             }));

// // //             // 3. Build phone → transaction map
// // //             const txMap = new Map();
// // //             txs.forEach(tx => {
// // //                 txMap.set(tx.phone, tx);
// // //             });

// // //             // 4. Combine
// // //             const combined = members.map(m => {
// // //                 const phone = m.phone_no;
// // //                 const tx = txMap.get(phone);
// // //                 // return {
// // //                 //     phone,
// // //                 //     name: tx?.name || "N/A",
// // //                 //     membershipType: m.membership_type,
// // //                 //     status: "Active",
// // //                 //     type: tx ? tx.subtitle : "Free",
// // //                 //     startDate: tx ? moment(tx.startDate.toDate()).format("YYYY-MM-DD") : "N/A",
// // //                 //     endDate: tx ? moment(tx.expiryDate.toDate()).format("YYYY-MM-DD") : "N/A"
// // //                 // };
// // //                 return {
// // //                     phone,
// // //                     // name: tx?.name || "N/A",
// // //                     membershipType: m.membership_type,
// // //                     status: "Active",
// // //                     type: tx ? tx.subtitle : "Free",
// // //                     startDate: tx
// // //                         ? moment(tx.startDate.toDate()).format("YYYY-MM-DD")
// // //                         : m.start_date
// // //                             ? moment(m.start_date.toDate()).format("YYYY-MM-DD")
// // //                             : "N/A",
// // //                     endDate: tx
// // //                         ? moment(tx.expiryDate.toDate()).format("YYYY-MM-DD")
// // //                         : m.end_date
// // //                             ? moment(m.end_date.toDate()).format("YYYY-MM-DD")
// // //                             : "N/A"
// // //                 };
// // //             });

// // //             setRows(combined);
// // //             setLoading(false);
// // //         }

// // //         loadMembers();
// // //     }, []);

// // //     if (loading) return <div>Loading...</div>;

// // //     return (
// // //         <table style={{ width: "100%", borderCollapse: "collapse" }}>
// // //             <thead>
// // //                 <tr>
// // //                     <th>Phone</th>
// // //                     {/* <th>Name</th> */}
// // //                     <th>Membership Type</th>
// // //                     <th>Status</th>
// // //                     <th>Type</th>
// // //                     <th>Start Date</th>
// // //                     <th>End Date</th>
// // //                 </tr>
// // //             </thead>
// // //             <tbody>
// // //                 {rows.map((r, idx) => (
// // //                     <tr key={idx}>
// // //                         <td>{r.phone}</td>
// // //                         {/* <td>{r.name}</td> */}
// // //                         <td>{r.membershipType}</td>
// // //                         <td>{r.status}</td>
// // //                         <td>{r.type}</td>
// // //                         <td>{r.startDate}</td>
// // //                         <td>{r.endDate}</td>
// // //                     </tr>
// // //                 ))}
// // //             </tbody>
// // //         </table>
// // //     );
// // // };

// // // export default ActiveMembersTable;



// // // // import React, { useEffect, useState } from "react";
// // // // import { collection, query, where, getDocs } from "firebase/firestore";
// // // // import db from "./Firebase"; // your initialized firestore
// // // // import moment from "moment";

// // // // const ActiveMembersTable = () => {
// // // //     const [loading, setLoading] = useState(true);
// // // //     const [rows, setRows] = useState([]);

// // // //     useEffect(() => {
// // // //         async function loadMembers() {
// // // //             setLoading(true);
// // // //             const startOfMonth = moment().startOf("month");
// // // //             const endOfMonth = moment().endOf("month");

// // // //             // 1. Query active memberships using only ONE inequality (on end_date)
// // // //             const memRef = collection(db, "nv_glow_membership");
// // // //             const memQ = query(
// // // //                 memRef,
// // // //                 where("end_date", ">=", startOfMonth.toDate())
// // // //             );
// // // //             const memSnap = await getDocs(memQ);
// // // //             const members = memSnap.docs
// // // //                 .map(d => ({ id: d.id, ...d.data() }))
// // // //                 .filter(m => moment(m.start_date.toDate()).isSameOrBefore(endOfMonth));

// // // //             // 2. Query all transactions for the current month
// // // //             const txRef = collection(db, "nv_transaction_history");
// // // //             const txQ = query(
// // // //                 txRef,
// // // //                 where("createdAt", ">=", startOfMonth.toDate()),
// // // //                 where("createdAt", "<=", endOfMonth.toDate())
// // // //             );
// // // //             const txSnap = await getDocs(txQ);
// // // //             const txs = txSnap.docs.map(d => ({
// // // //                 id: d.id,
// // // //                 ...d.data(),
// // // //             }));

// // // //             // 3. Create phone -> transaction map
// // // //             const txMap = new Map();
// // // //             txs.forEach(tx => {
// // // //                 txMap.set(tx.phone, tx);
// // // //             });

// // // //             // 4. Combine membership and transaction data
// // // //             const combined = members.map(m => {
// // // //                 const phone = m.phone_no;
// // // //                 const tx = txMap.get(phone);
// // // //                 return {
// // // //                     phone,
// // // //                     membershipType: m.membership_type,
// // // //                     status: tx
// // // //                         ? `Paid (${tx.price})`
// // // //                         : "Free",
// // // //                 };
// // // //             });

// // // //             setRows(combined);
// // // //             setLoading(false);
// // // //         }

// // // //         loadMembers();
// // // //     }, []);


// // // //     if (loading) return <div>Loading…</div>;

// // // //     return (
// // // //         <table style={{ width: "100%", borderCollapse: "collapse" }}>
// // // //             <thead>
// // // //                 <tr>
// // // //                     <th>Phone</th>
// // // //                     <th>Membership Type</th>
// // // //                     <th>Status</th>
// // // //                 </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //                 {rows.map((r, idx) => (
// // // //                     <tr key={idx}>
// // // //                         <td>{r.phone}</td>
// // // //                         <td>{r.membershipType}</td>
// // // //                         <td>{r.status}</td>
// // // //                     </tr>
// // // //                 ))}
// // // //             </tbody>
// // // //         </table>
// // // //     );
// // // // };

// // // // export default ActiveMembersTable;
